import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { BookingType } from 'Components/Types';

interface BookingState {
    currentBooking: BookingType | null;
}

const initialState: BookingState = {
    currentBooking: null,
};

const bookingSlice = createSlice({
    name: 'booking',
    initialState,
    reducers: {
        setCurrentBooking(state:any, action: PayloadAction<BookingType|null>) {
            state.currentBooking = action.payload;
        }
    }
});

export const { setCurrentBooking } = bookingSlice.actions;
export default bookingSlice.reducer;